import React from "react"
import {
  withStyles,
  WithStyles,
  createStyles,
  Theme,
  Typography,
} from "@material-ui/core"

import { flexBreakpoint } from "../styles"
import { PostPreview } from "../../../types/Post"
import Thumbnail from "../../Thumbnail"
import CardDivider from "../../CardDivider"
import { getMarginBottomCreator, CardMarginInfo } from "../../../utils/styles"
import PostLink from "../PostLink"
import ReadMoreButton from "../../ReadMoreButton"
import Title from "./Title"
import { buttonWidth } from "./styles"

const getPostWidth = (margin: string, posts: number): string =>
  `calc(100% / ${posts} - ${margin} / 2)`

interface BaseProps extends PostPreview, CardMarginInfo {}

const styles = ({ breakpoints: { up, between } }: Theme) => {
  const flexBreakpointUp = up(flexBreakpoint)
  const lg = up("lg")
  const xl = up("xl")

  const getMarginBottom = getMarginBottomCreator<BaseProps>()

  const bodyMargin = "1.5rem"

  return createStyles({
    root: {
      listStyle: "none",
      "& + &": {
        [between("xs", flexBreakpoint - 1)]: {
          marginTop: "3rem",
        },
      },
      [flexBreakpointUp]: {
        width: getPostWidth("2rem", 2),
        marginBottom: getMarginBottom("4rem", 2),
      },
      [lg]: {
        width: getPostWidth("2rem", 3),
      },
      [xl]: {
        width: getPostWidth("2.625rem", 4),
        marginBottom: getMarginBottom("7.625rem", 4),
      },
    },
    thumbnail: {
      marginBottom: "1.1875rem",
      [xl]: {
        marginBottom: "3.625rem",
      },
    },
    divider: {
      maxWidth: "7.75rem",
      marginBottom: "0.5rem",
      [flexBreakpointUp]: {
        marginBottom: "0.9375rem",
      },
    },
    content: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      [flexBreakpointUp]: {
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
      },
    },
    body: {
      marginRight: bodyMargin,
      maxWidth: `calc(100% - ${buttonWidth} - ${bodyMargin})`,
      flexShrink: 1,
      [flexBreakpointUp]: {
        marginBottom: "2.375rem",
        marginRight: 0,
        maxWidth: "100%",
      },
    },
  })
}

interface Props extends WithStyles<typeof styles>, PostPreview {
  postsAmount: number
  index: number
}

const Item = ({ classes, previewPicture, title, description, slug }: Props) => {
  return (
    <li className={classes.root}>
      <PostLink slug={slug}>
        <Thumbnail
          classes={{ root: classes.thumbnail }}
          imageData={previewPicture.localFile}
          alt={title}
        />
      </PostLink>
      <div className={classes.content}>
        <div className={classes.body}>
          <Title title={title} slug={slug} />
          <CardDivider classes={{ root: classes.divider }} />
          <Typography>{description}</Typography>
        </div>
        <ReadMoreButton slug={slug} />
      </div>
    </li>
  )
}

export default withStyles(styles)(Item)
